












































import { Component, Mixins, Prop } from "vue-property-decorator";
import { IContractProduct } from "@/models/contracts";
import Context from "@/mixins/context";

@Component
export default class CProdTags extends Mixins(Context) {
  // Props

  @Prop({ default: null })
  public cProd!: IContractProduct;

  @Prop({ default: "div" })
  public tag!: string;

  // Computed

  public get isVisible() {
    return (
      this.cProd?.in_trial ||
      !!this.cProd?.client_label ||
      !!this.$slots?.default?.length
    );
  }
}
